import { render } from "./Webshop.vue?vue&type=template&id=1db1924f"
import script from "./Webshop.vue?vue&type=script&lang=js"
export * from "./Webshop.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__